import { useState } from "react";
import { Plus, Trash2, Ruler } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const PRESETS = [["Ultrawide 21:9", 21, 9], ["Monitor 4:3", 4, 3], ["Monitor 16:10", 16, 10], ["Totem 3:4", 3, 4], ["Ledwall 32:9", 32, 9]];
const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "").slice(0, 24);

export function CustomFormatsEditor({ custom, onChange, baseUrl }) {
  const [label, setLabel] = useState("");
  const [w, setW] = useState("");
  const [h, setH] = useState("");
  const add = (l, cw, ch) => {
    const W = Number(cw), H = Number(ch);
    if (!l.trim() || !(W > 0) || !(H > 0)) return toast.error("Inserisci nome e proporzioni (es. 21 e 9)");
    const key = `custom_${slug(l) || Date.now()}`;
    if (custom.some((f) => f.key === key)) return toast.error("Formato già presente");
    if (custom.length >= 4) return toast.error("Massimo 4 formati personalizzati");
    onChange([...custom, { key, label: l.trim(), w: W, h: H }]);
    setLabel(""); setW(""); setH("");
  };
  return (
    <div className="rounded-lg bg-secondary/40 p-3 space-y-2" data-testid="custom-formats-editor">
      <Label className="text-xs flex items-center gap-1.5"><Ruler className="h-3.5 w-3.5" /> Formati personalizzati (per monitor particolari: ultrawide, 4:3, ledwall…)</Label>
      <p className="text-[11px] text-muted-foreground">Ogni formato aggiunge una colonna alla tabella. Il display sceglie in automatico il formato più vicino alle proporzioni dello schermo, oppure forzalo con <span className="font-mono-code">?format=chiave</span>.</p>
      {custom.map((f) => (
        <div key={f.key} className="flex items-center gap-2 text-xs" data-testid={`custom-format-${f.key}`}>
          <span className="font-semibold">{f.label}</span><span className="text-muted-foreground">{f.w}:{f.h}</span>
          <span className="font-mono-code text-[10px] text-muted-foreground truncate flex-1">{baseUrl}?format={f.key}</span>
          <Button size="icon" variant="ghost" className="h-6 w-6" onClick={() => onChange(custom.filter((x) => x.key !== f.key))} data-testid={`custom-format-remove-${f.key}`}><Trash2 className="h-3 w-3" /></Button>
        </div>
      ))}
      <div className="flex flex-wrap items-center gap-2">
        <Input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Nome (es. Monitor cassa)" className="h-7 text-[11px] w-44" data-testid="custom-format-label" />
        <Input type="number" min={1} value={w} onChange={(e) => setW(e.target.value)} placeholder="L" className="h-7 text-[11px] w-16" data-testid="custom-format-w" />
        <span className="text-xs">:</span>
        <Input type="number" min={1} value={h} onChange={(e) => setH(e.target.value)} placeholder="A" className="h-7 text-[11px] w-16" data-testid="custom-format-h" />
        <Button size="sm" variant="secondary" className="h-7 gap-1 text-[11px]" onClick={() => add(label, w, h)} data-testid="custom-format-add"><Plus className="h-3 w-3" /> Aggiungi</Button>
        <span className="text-[10px] text-muted-foreground">Rapidi:</span>
        {PRESETS.map(([l, pw, ph]) => <button key={l} type="button" onClick={() => add(l, pw, ph)} className="text-[10px] rounded-full border border-border px-2 py-0.5 hover:border-primary" data-testid={`custom-format-preset-${slug(l)}`}>{l}</button>)}
      </div>
    </div>
  );
}
